module.exports = __webpack_public_path__ + "img/gx.f519e6d2.png";